import React from 'react';
import '../template-file-css/document-file-template.css';


export const GENERAL_CaseTransfer = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='GENERAL_CaseTransfer' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'> <center> <h3> <b> CASE TRANSFER </b> </h3> </center>
                </p>
                <p className='w-750'> <center> <h3> <b> DOCUMENTO PARA TRANSFERIR LOS CASOS </b> </h3> </center>
                </p>

                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> NAME OF CLIENT/ NOMBRE DEL CLIENTE: </span> </td>
                        <td className='w-375'> <span className='eleHeader'> MEDICAID NUMBER/ NÚMERO DE MEDICAID: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtNameOfClient_1' name='txtNameOfClient_1' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtMedicaidNumber_1' name='txtMedicaidNumber_1' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'> CASE TRANSFERRED FROM (CURRENT PROVIDER NAME) CASO TRANSFERIDO DE:(NOMBRE DE PROVEEDOR DE CUAL DESEA TRANSFERIR:) </span> </p>

                <p className='w-750'> <input type='text' id='txtCaseCurrent' name='txtCaseCurrent' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'> ADDRESS/DIRECCIÓN </span>
                </p>

                <p className='w-750'> <input type='text' id='txtAddress_1' name='txtAddress_1' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'> CASE TRANSFERRED TO (NEW PROVIDER NAME) CASO TRANSFERIDO A: (NOMBRE DE PROVEEDOR A CUAL DESEA TRANSFERIR:) </span>
                </p>

                <p className='w-750'> <input type='text' id='txtCaseNew' name='txtCaseNew' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'> ADDRESS/DIRECCIÓN </span>
                </p>

                <p className='w-750'> <input type='text' id='txtAddress_2' name='txtAddress_2' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'> <b> REASONS FOR TRANSFER /MOTIVOS POR TRANSFERIR: </b> </span>
                </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbClientFamily' name='cbClientFamily' className='add-only' value='CLIENT/FAMILY RELOCATED' /> CLIENT/FAMILY RELOCATED/CAMBIO DE DOMICILIO DEL CLIENTE/DE LA FAMILIA
                            <br />
                            <input type='checkbox' id='cbFamilyRequest' name='cbFamilyRequest' className='add-only' value='CLIENT/FAMILY REQUEST' /> CLIENT/FAMILY REQUEST CHANGE/TRANSFER EL CLIENTE/LA FAMILIA PIDE CAMBIAR O TRANSFERIR
                            <br />
                            <input type='checkbox' id='cbOther' name='cbOther' className='add-only' value='OTHER' /> OTHER (SPECIFY)/OTRO (EXPLIQUE)
                        </td>
                    </tr>
                </table>

                <p className='w-750'> <input type='text' id='txtNameOfClient_1' name='txtNameOfClient_1' className='add-only' />
                </p>

                <p className='w-750'>
                    I, the &nbsp;
                    <input type='checkbox' id='cbClient_1' name='cbClient_1' className='add-only' value='client' /> client &nbsp;
                    <input type='checkbox' id='cbParent_1' name='cbParent_1' className='add-only' value='parent' /> parent &nbsp;
                    <input type='checkbox' id='cbGuardian_1' name='cbGuardian_1' className='add-only' value='guardian' /> guardian, &nbsp;
                    request my/my child's services be transferred as outlined above. I understand that I have the freedom to choose my provider.
                </p>

                <p className='w-750'>
                    Yo, &nbsp;
                    <input type='checkbox' id='cbElCliente_1' name='cbElCliente_1' className='add-only' value='el cliente' /> el cliente &nbsp;
                    <input type='checkbox' id='cbElPadre_1' name='cbElPadre_1' className='add-only' value='el padre' /> el padre &nbsp;
                    <input type='checkbox' id='cbElTutor_1' name='cbElTutor_1' className='add-only' value='el tutor' /> el tutor, &nbsp;
                    pide que los servicios míos o de mi hijo sean transferidos como se describe al principio de esta página. Entiendo que tengo la libertad de escoger un proveedor para mí o para mi hijo.
                </p>

                <p className='w-750'>
                    I, the &nbsp;
                    <input type='checkbox' id='cbClient_2' name='cbClient_2' className='add-only' value='client' /> client &nbsp;
                    <input type='checkbox' id='cbParent_2' name='cbParent_2' className='add-only' value='parent' /> parent &nbsp;
                    <input type='checkbox' id='cbGuardian_2' name='cbGuardian_2' className='add-only' value='guardian' /> guardian, &nbsp;
                    give my consent for the current provider/agency listed above to give the new provider/agency listed above a copy of my/my child's case management record. I give my consent for my new provider to get information including but not limited to intake, needs assessment, service plan, and follow-up documentation. I know that this information will be used to continue case management services for me/my child. This consent will expire three months from the date of signature unless I cancel it. I know that I must write to my case manager to cancel this consent. I know that this
                    consent will not affect my (or my child's) treatment, payment, enrollment or eligibility for case management services. I know that anyone who gets information as a result of this consent may share it with others as the law allows.
                </p>

                <p className='w-750'>
                    Yo, &nbsp;
                    <input type='checkbox' id='cbElCliente_2' name='cbElCliente_2' className='add-only' value='el cliente' /> el cliente &nbsp;
                    <input type='checkbox' id='cbElPadre_2' name='cbElPadre_2' className='add-only' value='el padre' /> el padre &nbsp;
                    <input type='checkbox' id='cbElTutor_2' name='cbElTutor_2' className='add-only' value='el tutor' /> el tutor, &nbsp;
                    autorizo/autoriza al proveedor o agencia actual listado arriba que le proporcione al nuevo proveedor o agencia listado arriba una copia de mi expediente de administración de casos o del expediente de administración de casos de mi hijo. Autorizo a nuevo proveedor mío o a nuevo proveedor de mi hijo que reciba información, incluyendo, pero sin limitarse a los mismos, los ingresos, la evaluación de necesidades, el plan de servicio y la documentación de servicios complementarios. Entiendo que esta información será utilizada para continuar los servicios de administración de
                    casos para mí o para mi hijo. Esta autorización expirará tres meses después de la fecha en que se firmó, a menos que la cancele. Entiendo que debo notificar por escrito a mi administrador de casos o al administrador de casos de mi hijo para cancelar esta autorización. Entiendo que esta autorización no afectará el tratamiento para mí o para mi hijo, los pagos, la inscripción o la elegibilidad para los servicios de administración de casos de mí o los de mi hijo. Entiendo que cualquier persona que reciba información como resultado de esta autorización la podrá compartir con otros, según lo permita la ley.
                </p>

                <table>
                    <tr>
                        <td className='signature w-550'> &nbsp; </td>
                        <td className='signature w-200'> &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-550'> CLIENT/PARENT GUARDIAN SIGNATURE/ FIRMA DEL CLIENTE/ DEL PADRE/DEL TUTOR: </td>
                        <td className='small w-200'> DATE/ FECHA: </td>
                    </tr>

                    <tr>
                        <td className='signature w-550'> &nbsp; </td>
                        <td className='signature w-200'> &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-550'> CASE MANAGER SIGNATURE/ FIRMA DEL ADMINISTRADOR DEL CASO: / PRINTED NAME OF CASE MANAGER/
                            NOMBRE DE ADMINISTRADOR DEL CASO: </td>
                        <td className='small w-200'> DATE/ FECHA: </td>
                    </tr>

                    <tr>
                        <td className='signature w-550'> &nbsp; </td>
                        <td className='signature w-200'> &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-550'> CASE MANAGEMENT PROVIDER NAME/ NOMBRE DEL PROVEEDOR : INTERPRETER SIGNATURE (IF APPLICABLE)/
                            FIRMA DEL INTÉRPRETE (EN CASO DE QUE LO HAYA): </td>
                        <td className='small w-200'> DATE/ FECHA: </td>
                    </tr>

                </table>





            </div>
        </form>

    )
}











